import React from 'react';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import DeepLink from '../../atoms/DeepLink/DeepLink';

interface Props {
  children?: any;
  enabled: boolean;
  item: Required<CardHcd>;
}

const TlcCardDeepLink: React.FC<Props> = ({ children, enabled, item }) =>
  enabled ? (
    <DeepLink
      href={{
        pathname: '/tlc/[center-id]/[practitioner-id]',
        query: {
          'center-id': item?.center?.id ?? '',
          'practitioner-id': item?.professional?.practitionerId ?? '',
          url: item?.url,
        },
      }}
    >
      {children}
    </DeepLink>
  ) : (
    <>{children}</>
  );

export default TlcCardDeepLink;
